import request from "@/utils/request";

// 获取用户详细信息
export function getInfo() {
  return request({
    url: "/getInfo",
    method: "get",
  });
}
// 获取用户详细信息
export function userList(data) {
  return request({
    url: "/dci/user/list",
    method: "post",
    data: data,
  });
}

// 上传文件OSS和DCI，需要同时成功
export function upload(data, onUploadProgress) {
  return request({
    headers: {
      "Content-Type": "multipart/form-data",
    },
    url: "/dci/file/upload",
    method: "post",
    data: data,
    onUploadProgress,
  });
}

// 通用文件上传（仅上传到本系统OSS）
export function commonUpload(data) {
  return request({
    headers: {
      "Content-Type": "multipart/form-data",
    },
    url: "/common/upload",
    method: "post",
    data: data,
  });
}

// 保存用户信息
export function userSave(data) {
  return request({
    url: "/dci/user/save",
    method: "post",
    data: data,
  });
}
// 新增本地用户信息到dci
export function addDci(data) {
  return request({
    url: "/dci/user/addDci",
    method: "post",
    params: data,
  });
}

// 更新本地用户信息到dci
export function updateDci(data) {
  return request({
    url: "/dci/user/updateDci",
    method: "post",
    params: data,
  });
}

// 更新用户信息
export function userUpdate(data) {
  return request({
    url: "/dci/user/update",
    method: "post",
    data: data,
  });
}

// 保存作品 DCI
export function workSave(data) {
  return request({
    url: "/dci/work/save",
    method: "post",
    data: data,
  });
}
// 查询作品列表DCI
export function workList(data, params) {
  return request({
    url: "/dci/work/list",
    method: "post",
    data: data,
    params: params,
  });
}

// 删除作品
export function workDelete(params) {
  return request({
    url: "/dci/work/delete",
    method: "post",
    params,
  });
}

// 取消/删除作品（管理员）
export function cancelDciWork(dciWorkId) {
  return request({
    url: "/dci/work/cancel",
    method: "post",
    params: { dciWorkId },
  });
}

// 获取作品详情
export function workInfo(params) {
  return request({
    url: "/dci/work/getInfo",
    method: "get",
    params,
  });
}

// 更新作品
export function workUpdate(data) {
  return request({
    url: "/dci/work/update",
    method: "post",
    data,
  });
}

// 提交反馈
export function feedBackSubmit(data) {
  return request({
    url: "/dci/feedBack/submit",
    method: "post",
    data,
  });
}

// 支付
export function payDciWork(data, params) {
  return request({
    url: "/dci/ali-pay/payDciWork",
    method: "post",
    data,
    params,
  });
}

// 数字登记保存
export function registrationSave(data) {
  return request({
    url: "/dci/registration/save",
    method: "post",
    data,
  });
}

// 获取数字登记列表
export function registrationList(data, params) {
  return request({
    url: "/dci/registration/list",
    method: "post",
    data,
    params,
  });
}

// 数字登记支付
export function payDigitalReg(data, params) {
  return request({
    url: "/dci/ali-pay/payDigitalReg",
    method: "post",
    data,
    params,
  });
}
// 取证支付
export function payRecordScreen(data) {
  return request({
    url: "/dci/ali-pay/payRecordScreen",
    method: "post",
    data,
  });
}
// 获取数字登记信息
export function registrationInfo(params) {
  return request({
    url: "/dci/registration/getInfo",
    method: "get",
    params,
  });
}
// 更新数字登记信息
export function registrationUpdate(data) {
  return request({
    url: "/dci/registration/update",
    method: "post",
    data,
  });
}

// 获取数字登记信息
export function dciRegistration(params) {
  return request({
    url: "/dci/registration/dciRegistration",
    method: "post",
    params,
  });
}

// 创建监控任务
export function createMonitorTask(params) {
  return request({
    url: "/dci/monitor/createMonitorTask",
    method: "post",
    params,
  });
}

// 创建取证任务
export function createRecordScreen(params) {
  return request({
    url: "/dci/monitor/createRecordScreen",
    method: "post",
    params,
  });
}

// 获取取证历史
export function getRecordScreenHis(params) {
  return request({
    url: "/dci/monitor/getRecordScreenHis",
    method: "get",
    params,
  });
}

// 根据证书编号查询用户信息
export function getByCertNo(params) {
  return request({
    url: "/dci/user/getByCert",
    method: "get",
    params,
  });
}

// 获取支付链接
export function dciGetPayUrl(data) {
  return request({
    url: "/dci/registration/dciGetPayUrl",
    method: "post",
    data,
  });
}

// 获取用户信息
export function dciGetInfo(params) {
  return request({
    url: "/dci/user/getInfo",
    method: "get",
    params,
  });
}

// 查询作品数量
export function statusCount(data) {
  return request({
    url: "/dci/work/statusCount",
    method: "post",
    data,
  });
}

// 获取支付结果
export function getPayResult(params) {
  return request({
    url: "/dci/ali-pay/getPayResult",
    method: "get",
    params,
  });
}

// 获取数字登记数量
export function registrationStatusCount(data) {
  return request({
    url: "/dci/registration/statusCount",
    method: "post",
    data,
  });
}

// 获取用户列表
export function systemUserList(data) {
  return request({
    url: "/system/user/list",
    method: "get",
    params: data,
  });
}

// 用户密码重置
export function resetUserPwd(userId, password) {
  const data = {
    userId,
    password,
  };
  return request({
    url: "/system/user/resetPwd",
    method: "put",
    data: data,
  });
}

// 用户状态修改
export function changeUserStatus(userId, status) {
  const data = {
    userId,
    status,
  };
  return request({
    url: "/system/user/changeStatus",
    method: "put",
    data: data,
  });
}

// 新增用户
export function addUser(data) {
  return request({
    url: "/system/user",
    method: "post",
    data: data,
  });
}

// 修改用户
export function updateUser(data) {
  return request({
    url: "/system/user",
    method: "put",
    data: data,
  });
}

// 发票列表
export function invoiceList(data, params) {
  return request({
    url: "/invoice/list",
    method: "post",
    data: data,
    params,
  });
}

// 订单列表
export function orderList(data, params) {
  return request({
    url: "/dci/order/list",
    method: "post",
    data: data,
    params,
  });
}

// 获取未完成订单金额
export function undoneAmount(data) {
  return request({
    url: "/dci/order/undoneAmount",
    method: "post",
    data,
  });
}

// 发票申请
export function invoiceApply() {
  return request({
    url: "/invoice",
    method: "get",
  });
}

// 支付监控
export function payMonitor(data) {
  return request({
    url: "/dci/ali-pay/payMonitor",
    method: "post",
    data,
  });
}

// 查询作品
export function doQueryDci(params) {
  return request({
    url: "/dci/work/doQueryDci",
    method: "get",
    params,
  });
}

// 查询监控结果
export function queryMonitorResult(params) {
  return request({
    url: "/dci/monitor/queryMonitorResult",
    method: "get",
    params,
  });
}
// 查询监控记录
export function getMonitorRecord(params) {
  return request({
    url: "/dci/monitor/getMonitorRecord",
    method: "get",
    params,
  });
}

// 退款
export function refund(params) {
  return request({
    url: "/dci/ali-pay/refund",
    method: "get",
    params,
  });
}


// 补证
export function retryDigitalRegister(params) {
  return request({
    url: "/dci/registration/retryDigitalRegister",
    method: "post",
    params,
  });
}
// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
  const data = {
    oldPassword,
    newPassword
  }
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'put',
    data: data
  })
}

// 修改用户个人信息
export function updateUserProfile(data, params) {
  return request({
    url: '/system/user/profile',
    method: 'put',
    data,
    params
  })
}

// /dci/user/getInfoByDciUserId?dciUserId= 
// 根据dciUserId获取用户信息
export function getInfoByDciUserId(params) {
  return request({
    url: '/dci/user/getInfoByDciUserId',
    method: 'get',
    params
  })
}

// 查询公告列表
export function listNotice(query) {
  return request({
    url: '/system/notice/list',
    method: 'get',
    params: query
  })
}

// 获取用户余额
export function getUserBalance() {
  return request({
    url: '/dci/user/getUserBalance',
    method: 'get'
  })
}

// 批量下载
export function downloadBatch(data) {
  return request({
    url: '/common/downloadBatch',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

// 根据内容ID批量下载dci申领信息摘要
export function dciWorkDownloadBatch(data) {
  return request({
    url: '/dci/work/downloadBatch',
    method: 'post',
    data,
  })
}

// 充值支付
export function payCharge(params) {
  return request({
    url: '/dci/ali-pay/payCharge',
    method: 'post',
    params,
  })
}

// 对公充值用户申请
export function chargeUserApply(data) {
  return request({
    url: '/dci/charge/userApply',
    method: 'post',
    data,
  })
}

// 获取充值记录列表
export function chargeGetList(params) {
  return request({
    url: '/dci/charge/getList',
    method: 'post',
    params,
  })
}

// 用户充值退款申请
export function balanceRefund(data) {
  return request({
    url: '/dci/charge/balanceRefund',
    method: 'post',
    data,
  })
}

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  return request({
    url: '/system/dict/data/type/' + dictType,
    method: 'get'
  })
}
